import content from './content/cfd-trading.json';

export const cfdTradingMock = {
  name: 'cfd-trading',
  layoutType: 1,
  areasList: [
    {
      id: 'cfd-trading-main',
      componentName: 'Comp:CfdTradingPage',
      content: JSON.stringify(content)
    }
  ]
};
